import { useEffect, useState } from 'react'

export const useIsWebView = () => {
  const [isWebView, setIsWebView] = useState<boolean | null>(false)

  useEffect(() => {
    const userAgent = navigator.userAgent

    // Check for injected WebView object (React Native WebView)
    const isReactNativeWebView =
      (window as any).ReactNativeWebView !== undefined

    // Check for common WebView user agents (iOS & Android)
    const isAndroidWebView =
      /wv|Android.*Version\/[\d.]+.*Chrome\/[.0-9]*\sMobile/.test(userAgent)
    const isIOSWebView = /\(iP(hone|od|ad);.*AppleWebKit(?!.*Safari)/.test(
      userAgent
    )

    const isWebView = /wv|webview/.test(userAgent?.toLowerCase())

    setIsWebView(
      isWebView || isReactNativeWebView || isAndroidWebView || isIOSWebView
    )
  }, [])

  return isWebView
}
